import { 
  usdtContract,
  safeContract, spp2lvContract, spp2lvConAdd

        } from "./ConAddsAndABIs"
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";

function TheSafePresalePhase2LadderVault(){

const [buySafeValue, setBuySafeValue] = useState(""); 
const [remainingSafe, setRemainingSafe] = useState('');
const [usdcGenerated, setUsdcGenerated] = useState('');
const [tranche, setTranche] = useState('');
const [trancheAmount, setTrancheAmount] = useState('');
const [tranchePrice, setTranchePrice] = useState('');
const [trancheSales, setTrancheSales] = useState('');
const [trancheRemaining, setTrancheRemaining] = useState('');

useEffect(() => {  

// - - - - - - - - - - 
const getTotalUsdtRewards = async () => {
    const a = await spp2lvContract.currentTranch();
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const c = await spp2lvContract.trancheAmount(a) / (10 ** 18);
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const e = await spp2lvContract.tranchePrice(a) / 1000000;
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 5, maximumFractionDigits: 5})
    const g = await spp2lvContract.trancheSales(a) / (10 ** 18);
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const i = c - g;
    const j = i.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const k = await safeContract.balanceOf(spp2lvConAdd) / (10 ** 18);
    const l = k.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const m = await spp2lvContract.totalUSDTGenerated() * 10 / 10;
    const n = m.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})

    setTranche(b)
    setTrancheAmount(d)
    setTranchePrice(f)
    setTrancheSales(h)
    setTrancheRemaining(j)
    setRemainingSafe(l)
    setUsdcGenerated(n)


  }  

  getTotalUsdtRewards()
  .catch(console.error)


})

const handleBuySafeValueChange = (e) => {
    setBuySafeValue(e.target.value);
    }  
   
const handleBuySafeValueSubmit = async (e) => {
    e.preventDefault();
    console.log(buySafeValue)
    const tranche = await spp2lvContract.currentTranch();
    const price = await spp2lvContract.tranchePrice(tranche) / 1;
    const safePerUsd = 1000000 / price
    const inUsdc = buySafeValue * (10 ** 6) / safePerUsd
    /*const inUsdca = inUsdc.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const uintValuea = ethers.utils.parseUnits(inUsdca, 6)*/
    const txna = await usdtContract.approve(spp2lvConAdd, inUsdc)
    await txna.wait();  
    const txnb = await spp2lvContract.buySafeFromSpp2v(buySafeValue)
    await txnb.wait();
    setBuySafeValue(0);
    }

return ( 
  <div>
        <h2>Presale Phase 2 (Asset Backing Liquidity) Ladder Vault</h2><br/>

        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange} value={buySafeValue} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy SAFE for {tranchePrice} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Metrics</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Tranche</td>
                <td className="column2">{tranche}</td>
            </tr>          
            <tr>
                <td>Tranche Price</td>
                <td className="column2">{tranchePrice} $USDC per $SAFE</td>
            </tr>                
            <tr>
                <td>Tranche Size</td>
                <td className="column2">{trancheAmount} $SAFE</td>
            </tr>
            <tr>
                <td>Tranche Sales</td>
                <td className="column2">{trancheSales} $SAFE</td>
            </tr>   
            <tr>
                <td>Tranche Remaining</td>
                <td className="column2">{trancheRemaining} $SAFE</td>
            </tr>  
            <tr>
                <td>Remaining Safe for Sale</td>
                <td className="column2">{remainingSafe} $SAFE</td>
            </tr>             
            <tr>
                <td>Total USDC Generated</td>
                <td className="column2">{usdcGenerated} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />
  

  </div>
  
)

}


export default TheSafePresalePhase2LadderVault;